export default __webpack_public_path__ + "static/media/BV_Certification_NP4457.6f17b050.svg";